export const bar_chart_alt = () => (
  <path
    d="M12 20V10m6 10V4M6 20v-4"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
